/**
 * KaryawanPreview Component
 * Display selected employee information with logo
 */

import React from "react";
import { getInitials } from "../utils/dataTransformers";

const KaryawanPreview = ({ karyawan }) => {
  if (!karyawan) return null;

  return (
    <div className="karyawan-option-preview">
      <img
        src="/logo-rs.png"
        alt="Logo Rumah Sakit"
        className="hospital-logo"
      />

      <div className="karyawan-text">
        <div className="karyawan-name">{karyawan.nama || "-"}</div>
        <div className="karyawan-sep" />
        <div className="karyawan-dept">{karyawan.departemen || "-"}</div>
      </div>

      {karyawan.photo_url ? (
        <img
          className="karyawan-photo-right"
          src={karyawan.photo_url}
          alt={karyawan.nama}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <div className="karyawan-photo-right initials">
          {getInitials(karyawan.nama)}
        </div>
      )}
    </div>
  );
};

export default KaryawanPreview;
